import React, { useState, useEffect } from 'react';
import DataTable from '../Common/DataTable';
import { api } from '../../services/api';

export default function WorkReports({ user }) {
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedContractId, setSelectedContractId] = useState(null);

  // טען contracts מה-user
  const contracts = user?.contracts || [];
  
  // בחר contract ראשון אם יש
  useEffect(() => {
    if (contracts.length > 0 && !selectedContractId) {
      setSelectedContractId(contracts[0].DocNum || contracts[0].id);
    }
  }, [contracts, selectedContractId]);

  // טען נתונים
  useEffect(() => {
    if (!selectedContractId || !user) return;

    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);
        
        const response = await api.getReport(
          user.userCode,
          user.type,
          selectedContractId
        );
        
        // אם השרת מחזיר columns + data
        if (response.columns && response.data) {
          setColumns(response.columns);
          setData(response.data);
        } 
        // אם השרת מחזיר רק data (array) - זה מה שקורה ב-report
        else if (Array.isArray(response)) {
          setData(response);
          // אם אין columns - נצטרך לקבל אותם מהשרת
          // כרגע נשאיר ריק - השרת צריך להחזיר columns
          setColumns([]);
        }
        // אם השרת מחזיר אובייקט עם data
        else if (response.data) {
          setColumns(response.columns || []);
          setData(response.data);
        }
        // אם השרת מחזיר משהו אחר - נסה להמיר ל-array
        else {
          setData([]);
          setColumns([]);
        }
      } catch (err) {
        console.error('Error fetching work reports:', err);
        setError(err.message);
    } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedContractId, user]);

  const handleContractChange = (contractId) => {
    setSelectedContractId(contractId);
  };

  if (loading && columns.length === 0) {
    return (
      <div style={{ padding: 8, textAlign: 'center' }}>
        <div>טוען...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div style={{ padding: 16, textAlign: 'center', color: 'red' }}>
        שגיאה בטעינת הדוח: {error}
      </div>
    );
  }

  if (!columns || columns.length === 0) {
    return (
      <div style={{ padding: 8, textAlign: 'center' }}>
        אין עמודות להצגה
      </div>
    );
  }

  return (
    <div style={{ padding: '8px 8px 2px 8px' }}>
      <DataTable 
        columns={columns} 
        data={data} 
        contracts={contracts.map(c => ({
          id: c.DocNum || c.id,
          name: c.U_Project || c.name
        }))}
        onContractChange={handleContractChange}
      />
    </div>
  );
}
